import { useTranslation } from "react-i18next";
import styles from "./ThemeToggle.module.css";

const LANGUAGES: { code: string; label: string }[] = [
  { code: "en", label: "EN" },
  { code: "es", label: "ES" },
];

export default function LanguageToggle() {
  const { i18n, t } = useTranslation();
  const active = i18n.language.startsWith("es") ? "es" : "en";

  return (
    <div className={styles.group} role="radiogroup" aria-label={t("language.ariaLabel")}>
      {LANGUAGES.map((lang) => (
        <button
          key={lang.code}
          type="button"
          role="radio"
          aria-checked={active === lang.code}
          title={lang.label}
          className={`${styles.option} ${styles.optionText} ${
            active === lang.code ? styles.optionActive : ""
          }`}
          onClick={() => i18n.changeLanguage(lang.code)}
        >
          {lang.label}
        </button>
      ))}
    </div>
  );
}
